var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RESET_WP, TOGGLE_WP_UPDATE } from '../actions/toggleWidePreviewer';
var initialState = {
    visible: false,
    src: null,
};
export function widePreviewerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TOGGLE_WP_UPDATE:
            return __assign(__assign({}, state), { visible: action.payload.value, src: action.payload.src });
        case RESET_WP:
            return __assign(__assign({}, state), { visible: action.payload.value, src: action.payload.src });
        default:
            return state;
    }
}
;
//# sourceMappingURL=toggleWidePreviewer.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RESET_WP, TOGGLE_WP_UPDATE } from '../actions/toggleWidePreviewer';
var initialState = {
    visible: false,
    src: null,
};
export function widePreviewerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TOGGLE_WP_UPDATE:
            return __assign(__assign({}, state), { visible: action.payload.value, src: action.payload.src });
        case RESET_WP:
            return __assign(__assign({}, state), { visible: action.payload.value, src: action.payload.src });
        default:
            return state;
    }
}
;
//# sourceMappingURL=toggleWidePreviewer.js.map